import BunkeyAPI from "../api/BunkeyAPI";
import {
  ASSET_EXPLORE_GET_DATA,
  ASSET_EXPLORE_GET_DATA_FAILURE,
  ASSET_EXPLORE_GET_DATA_SUCCESS,
  ASSET_DELETE,
  ASSET_DELETE_SUCCESS,
  ASSET_DELETE_FAILURE,
  ASSET_EXPLORE_ACTIVEVIEW,
  ASSET_EXPLORE_EDIT,
  ASSET_EXPLORE_EDIT_SUCCESS,
  ASSET_EXPLORE_EDIT_FAILURE,
  ASSET_EXPLORE_SET_SELECT,
  ASSET_EXPLORE_UNSET_SELECT,
  ASSET_EXPLORE_EMPTY,
  ASSET_EXPLORE_DELETE,
  ASSET_EXPLORE_DELETE_SUCCESS,
  ASSET_EXPLORE_DELETE_FAILURE,
  ASSET_EXPLORE_EDIT_SELECT,
  ASSET_EXPLORE_EDIT_UNSET_SELECT,
  ASSET_EXPLORE_EXPAND_SELECT,
  ASSET_EXPLORE_EXPAND_UNSET_SELECT,
  ASSET_EXPLORE_SHARE_SELECT,
  ASSET_EXPLORE_SHARE_UNSET_SELECT,
  ASSET_EXPLORE_MOVE,
  ASSET_EXPLORE_MOVE_SUCCESS,
  ASSET_EXPLORE_MOVE_FAILURE,
  ASSET_EXPLORE_CHECK_SELECT,
  ASSET_EXPLORE_UNCHECK_SELECT,
  MULTIPLE_EXPLORE_OPTIONS_ACTIVATE,
  MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE,
  MULTIPLE_EXPLORE_OPTIONS_DONE,
  ASSETS_EXPLORE_MULTI_DELETE,
  ASSETS_EXPLORE_MULTI_DELETE_SUCCESS,
  ASSETS_EXPLORE_MULTI_DELETE_FAILURE,
  ASSETS_EXPLORE_MULTI_MOVE,
  ASSETS_EXPLORE_MULTI_MOVE_SUCCESS,
  ASSETS_EXPLORE_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_EXPLORE,
  SCROLL_EXPLORE,
} from "../constants/assets-explore-types";
import store from "../store";

import {
  sendNotification,
  permissionsDefault,
  validateImageSpecialExtensions,
  //MAX_PAG_SIZE,
} from "../utils";
// import { goToPage } from "./SearchAction";


export const cleanDataBackExplore = () => {
  return dispatch => {
    dispatch({
      type: CLEAN_DATA_BACK_EXPLORE,
    })
  }
}
export const scrollExplore = (isShow,page) => {
  return dispatch => {
    dispatch({
      type: SCROLL_EXPLORE,
      payload: {
        showScrolling: isShow,
        pageScrolling: page
      },
    })
  }
}

export const getExplore = (
  workclient,
  folder,
  page = 1,
  order,
  isFetching = true,
  data = [],
  newLimit = 1000
) => {
  const user = store.getState().authUser.user;
  let isShared = store
    .getState()
    .assetsShared.data.find((r) => r._id === folder);
  if (!isShared) {
    isShared = store
      .getState()
      .assetsExplore.data.find((r) => r._id === folder && r.isShared === true);
  }
  return (dispatch) => {
    const { orderBy } = store.getState().assetsExplore;
    // const pageToGo = newLimit !== limit ? 1 : page;
    const filterOrder =
      order !== orderBy && order && order !== "" ? order : orderBy;
    // dispatch(goToPage(pageToGo));
    dispatch({
      type: ASSET_EXPLORE_GET_DATA,
      payload: {
        folder,
        isFetching: data.length === 0 ? isFetching : false,
        data,
        isLoadingScroll: data.length !== 0 ? true : false,
      },
    });
    BunkeyAPI({
      url: `/clients/${workclient}/folders/${folder}?page=${page}&limit=${newLimit}&orderBy=${filterOrder}&isShared=${
        isShared ? true : false
      }`,
      method: "GET",
    })
      .then((resp) => {
        dispatch({
          type: ASSET_EXPLORE_GET_DATA_SUCCESS,
          payload: {
            user,
            headers: resp.headers,
            page: page,
            limit: newLimit,
            orderBy: filterOrder,
            data: resp.data
              /* .filter((r) =>
                ["folder", "document", "image", "video"].includes(r.type)
              ) */
              .map((r) => {
                return {
                  _id: r._id,
                  type: validateImageSpecialExtensions(r.originalURL)
                    ? "document"
                    : r.type,
                  name: r.name,
                  lowQualityURL: r.lowQualityURL,
                  mediaQualityURL: r.mediaQualityURL,
                  originalURL: r.originalURL,
                  metadata: r.metadata,
                  parents: r.parents,
                  createdAt: r.createdAt,
                  group: r.group,
                  user:
                    r.user && r.username
                      ? { id: r.user, name: r.username }
                      : { id: "", name: "" },
                  isShared: r.isShared,
                  tagProtocol: r.tagProtocol,
                  longDescription: r.longDescription,
                  objectGroups: r.objectGroup,
                  fileSizeFormat: r.fileSizeFormat,
                  matrix: permissionsDefault().map((def) => {
                    const exists = r.group.find((r) =>
                      r.permissions.find(
                        (item) =>
                          item.action === def.action && item.enabled === true
                      )
                    );
                    return {
                      action: def.action,
                      enabled: exists ? true : false,
                    };
                  }),
                  uuid: r.uuid,
                  documentPages: r.documentPages,
                  viewFromHost: r.viewFromHost,
                };
              }),
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: ASSET_EXPLORE_GET_DATA_FAILURE,
          payload: err,
        });
      });
  };
};

export const deleteAsset = (workclient, id) => {
  return (dispatch) => {
    dispatch({ type: ASSET_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: "DELETE",
    })
      .then((resp) => {
        dispatch({
          type: ASSET_DELETE_SUCCESS,
          payload: {
            data: id,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: ASSET_DELETE_FAILURE,
          payload: err,
        });
      });
  };
};

export const setSelectExploreAsset = (
  item,
  indice,
  from,
  verticalCount,
  horizontalCount
) => {
  const { activeView } = store.getState().assetsExplore;
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_SET_SELECT,
      payload: {
        data: item,
        indice: from ? indice : indice.replace("undefined", activeView),
        from: from ? from : activeView,
        verticalCount,
        horizontalCount,
      },
    });
  };
};

export const unsetSelectExploreAsset = () => {
  return (dispatch) => {
    dispatch({ type: ASSET_EXPLORE_UNSET_SELECT });
  };
};

export const setExploreActiveView = (view) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_ACTIVEVIEW,
      payload: {
        activeView: view,
      },
    });
  };
};

export const deleteExploreAsset = (workclient, id, intl, multiple) => {
  return (dispatch) => {
    dispatch({ type: ASSET_EXPLORE_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: "DELETE",
    })
      .then((resp) => {
        dispatch({
          type: ASSET_EXPLORE_DELETE_SUCCESS,
          payload: {
            workclient,
            id,
          },
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "asset_has_been_deleted" })
        );
        // }
      })
      .catch((err) => {
        dispatch({
          type: ASSET_EXPLORE_DELETE_FAILURE,
          payload: {
            workclient,
            id,
            error: err,
          },
        });
        // if (multiple) {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_deleting_asset" })
        );
        // }
      });
  };
};

export const emptyExplore = () => {
  return (dispatch) => {
    dispatch({ type: ASSET_EXPLORE_EMPTY });
  };
};

export const setEditExploreAsset = (workclient, asset) => {
  return (dispatch) => {
    dispatch({ type: ASSET_EXPLORE_EDIT });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: "PUT",
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags,
          createdDate: asset.metadata.createDate,
          dueDate: asset.metadata.dueDate,
        },
      },
    })
      .then((resp) => {
        dispatch({
          type: ASSET_EXPLORE_EDIT_SUCCESS,
          payload: {
            data: asset,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: ASSET_EXPLORE_EDIT_FAILURE,
          payload: err,
        });
      });
  };
};

export const setSelectEditExploreAsset = (asset, editAssetTab) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab,
      },
    });
  };
};

export const unsetSelectEditExploreAsset = () => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_EDIT_UNSET_SELECT,
    });
  };
};

export const setSelectExpandExploreAsset = (asset) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_EXPAND_SELECT,
      payload: {
        data: asset,
      },
    });
  };
};

export const unsetSelectExpandExploreAsset = () => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_EXPAND_UNSET_SELECT,
    });
  };
};

export const setSelectShareExploreAsset = (asset) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_SHARE_SELECT,
      payload: {
        data: asset,
      },
    });
  };
};

export const unsetSelectShareExploreAsset = () => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_SHARE_UNSET_SELECT,
    });
  };
};

export const moveExploreAsset = (workclient, asset, folder, intl, multiple) => {
  return (dispatch) => {
    dispatch({ type: ASSET_EXPLORE_MOVE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: "PUT",
      data: {
        action: "move",
        folder: folder,
      },
    })
      .then((resp) => {
        dispatch({
          type: ASSET_EXPLORE_MOVE_SUCCESS,
          payload: {
            data: asset,
            headers: resp.headers,
            folder: folder,
          },
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "asset_has_been_moved" })
        );
        // }
      })
      .catch((err) => {
        dispatch({
          type: ASSET_EXPLORE_MOVE_FAILURE,
          payload: err,
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "the_asset" })} ${
            asset.name
          } ${intl.formatMessage({ id: "could_not_move" })}`
        );
      });
  };
};

export const setCheckExploreAsset = (asset) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_CHECK_SELECT,
      payload: asset,
    });
  };
};

export const unsetCheckExploreAsset = (asset) => {
  return (dispatch) => {
    dispatch({
      type: ASSET_EXPLORE_UNCHECK_SELECT,
      payload: asset,
    });
  };
};

export const activateExploreOptions = () => {
  return (dispatch) => {
    dispatch({
      type: MULTIPLE_EXPLORE_OPTIONS_ACTIVATE,
    });
  };
};

export const deactivateExploreOptions = () => {
  return (dispatch) => {
    dispatch({
      type: MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE,
    });
  };
};

export const isDoneMultipeExploreOptions = () => {
  return (dispatch) => {
    dispatch({
      type: MULTIPLE_EXPLORE_OPTIONS_DONE,
    });
  };
};
export const multiDeleteExploreAsset = (workclient, intl, items) => {
  return (dispatch) => {
    dispatch({ type: ASSETS_EXPLORE_MULTI_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: 'PUT',
      data: {
        data: items
      }
    })
      .then((resp) => {
        dispatch({
          type: ASSETS_EXPLORE_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items,
          },
        })
        sendNotification(
          'success',
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        )
      })
      .catch((err) => {
        dispatch({
          type: ASSETS_EXPLORE_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err,
          },
        })
        sendNotification(
          'error',
          intl,
          `${intl.formatMessage({ id: 'assets_has_not_been_deleted' })}`
        )
      })
  }
}
export const moveMultiselectExploreAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_EXPLORE_MULTI_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: 'PUT',
      data: {
        data: ids
      }
    }).then(resp => {
      dispatch({
        type: ASSETS_EXPLORE_MULTI_MOVE_SUCCESS,
        payload: {
          ids: ids,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSETS_EXPLORE_MULTI_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'assets_could_not_moved' })}`)
    })
  }
}
